import * as React from 'react';
import classNames from 'classnames';

import { ISeoState } from '../../../../common/state';
import { IBreadcrumb } from '../../../../offer';
import { Breadcrumbs } from '../../Breadcrumbs';
import * as styles from './index.css';

export interface IHeaderDefaultProps {
  seo: ISeoState;
  breadcrumbs: IBreadcrumb[];
  isRedesign: boolean;
}

export const HeaderDefault: React.FC<IHeaderDefaultProps> = ({ breadcrumbs, seo, isRedesign }) => {
  const { h1 } = seo;

  return (
    <div className={classNames(styles['wrapper'], isRedesign && styles['wrapper_redesign'])}>
      <Breadcrumbs breadcrumbs={breadcrumbs} h1={h1} />
    </div>
  );
};
